import React from "react"
import styled from "styled-components"

const StyledAddress = styled.address`
  line-height: 1.4;

  span:last-child {
    padding-inlinse-start: 0.5rem;
  }

  dl {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    gap: 0.5rem;
  }
`
export default function ContactInfo() {
  return (
    <StyledAddress aria-label="Contact Information">
      <p>●個人情報に関するお問い合わせ〇</p>
      <p>
        <span>フランソアグループ</span>
        <span>お客様相談室</span>
      </p>
      <p>福岡県糟屋郡新宮町緑ケ浜3丁目1-1</p>
      <dl>
        <dt>TEL:</dt>
        <dd>0120-894-180</dd>
      </dl>
    </StyledAddress>
  )
}
